import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { IConductorComponentData } from "@faire/retailer-visitor-shared/features/Conductor/types";
import { IProductMessageByViewport } from "@faire/web-api--source/indigofair/retailer/IProductMessageByViewport";

export type BannerContent =
  | IConductorComponentData
  | IProductMessageByViewport
  | React.ReactNode
  | undefined;
export type BannerSectionWithKeyAndContent = Array<
  Partial<Record<PromoBannerType, BannerContent>>
>;

export enum BannerSectionVariant {
  FAIRE_DIRECT_INCENTIVES,
  MARKET_COUNTDOWN,
  FIRST_ORDER_INCENTIVES,
  POST_FCO_BANNERS,
  ADDITIONAL_BANNERS,
  EMPLOYEE_GRANTED_FREE_FREIGHT,
}

export const ORDERED_FAIRE_DIRECT_BANNERS = [
  PromoBannerType.FAIRE_DIRECT_INCENTIVES,
];

export const ORDERED_MARKET_COUNTDOWN_BANNERS = [
  PromoBannerType.MARKET_COUNTDOWN,
];

// only section not in order
export const UNORDERED_FIRST_ORDER_INCENTIVES_BANNERS = [
  PromoBannerType.FIRST_ORDER_INCENTIVE,
  PromoBannerType.OPEN_WITH_FAIRE,
  PromoBannerType.PAYMENT_TERMS,
];

// post-FCO -> should only show if POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024 is part of array
export const ORDERED_POST_FCO_BANNERS = [
  PromoBannerType.POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024,
  PromoBannerType.DISCOVERY_TERMS,
];

// additional banners
export const ORDERED_ADDITIONAL_BANNERS = [
  PromoBannerType.POS_INTEGRATION,
  PromoBannerType.OPEN_WITH_FAIRE,
  PromoBannerType.SPECIAL_HOLIDAY_NET90,
  PromoBannerType.OPENING_ORDER_INCENTIVES,
  PromoBannerType.AMEX_INCENTIVE,
  PromoBannerType.WAREHOUSE_SALE,
  PromoBannerType.REFERRAL_FOLLOWUP,
  PromoBannerType.DISCOVERY_TERMS,
];

export const ORDERED_EMPLOYEE_GRANTED_FREE_FREIGHT_BANNERS = [
  PromoBannerType.EMPLOYEE_GRANTED_FREE_FREIGHT,
];

export const IMP_TO_PROMO_BANNER_MAP: Record<string, PromoBannerType> = {
  POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024:
    PromoBannerType.POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024,
  FIRST_ORDER_INCENTIVE: PromoBannerType.FIRST_ORDER_INCENTIVE,
  OPEN_WITH_FAIRE: PromoBannerType.OPEN_WITH_FAIRE,
  PAYMENT_TERMS: PromoBannerType.PAYMENT_TERMS,
  DISCOVERY_TERMS: PromoBannerType.DISCOVERY_TERMS,
};

export const BANNERS_SECTION_WITH_ORDERED_BANNERS_MAP: Record<
  BannerSectionVariant,
  PromoBannerType[]
> = {
  [BannerSectionVariant.FAIRE_DIRECT_INCENTIVES]: ORDERED_FAIRE_DIRECT_BANNERS,
  [BannerSectionVariant.MARKET_COUNTDOWN]: ORDERED_MARKET_COUNTDOWN_BANNERS,
  // TODO: Will adjust for ordering
  [BannerSectionVariant.FIRST_ORDER_INCENTIVES]:
    UNORDERED_FIRST_ORDER_INCENTIVES_BANNERS,
  [BannerSectionVariant.POST_FCO_BANNERS]: ORDERED_POST_FCO_BANNERS,
  [BannerSectionVariant.ADDITIONAL_BANNERS]: ORDERED_ADDITIONAL_BANNERS,
  [BannerSectionVariant.EMPLOYEE_GRANTED_FREE_FREIGHT]:
    ORDERED_EMPLOYEE_GRANTED_FREE_FREIGHT_BANNERS,
};
